import type {BasicObject, NavigatorScreenProps} from '@/types';
import React from 'react';
import globalStore from '@/services/global.state';
import {goBack} from '@/utils';
import {useTranslation} from 'react-i18next';
import {RechargeCoreShell} from './recharge-core-shell';
import {useRechargeProgressiveCore} from './use-recharge-progressive-core';
import {useRechargeProgressiveStoreLifecycle} from '@fe-progressive/package-progressive/recharge';
import {RECHARGE_PROGRESSIVE_DEFAULT_CRYPTO_ENABLED} from './recharge-progressive.constants';

export default function RechargeProgressivePage(
  _props: NavigatorScreenProps & BasicObject,
): React.JSX.Element {
  const {t} = useTranslation();
  const vm = useRechargeProgressiveCore();

  useRechargeProgressiveStoreLifecycle({
    enableCryptoDefault: RECHARGE_PROGRESSIVE_DEFAULT_CRYPTO_ENABLED,
  });

  if (!globalStore.isWeb) {
    return (
      <div className="p-4 text-sm text-gray-800">
        {t('rechargeProgressive.webOnly')}
      </div>
    );
  }

  return <RechargeCoreShell vm={vm} onBack={goBack} />;
}
